import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import { useQuery, UseQueryResult } from 'react-query';
import {
    getDefaultHeaders,
    instance as axiosInstance,
    withHeaders,
} from '../core';
import { EdgeDefinition } from '../lib';

const getServerDataStatus = async (
    url: string,
    token: string
): Promise<AxiosResponse<EdgeDefinition, any>> => {
    const headers = getDefaultHeaders(token);
    return axiosInstance().get(url, withHeaders(headers));
};

export const useServerDataStatus = (): UseQueryResult<
    AxiosResponse<any>,
    unknown
> => {
    const { getToken } = useAuth();

    return useQuery('data-server-status', async () =>
        getServerDataStatus('/graphchain/health', getToken())
    );
};
